import { Pipe, PipeTransform } from '@angular/core';
import { ContentService } from '../../services/content/content.service';
import { Models } from '@ibexfusion/models';

@Pipe({
  name: 'streetConditionsPipe'
})
export class StreetConditionsPipe implements PipeTransform {
  public mediaPath = 'https://ibexfusion5.s3.eu-central-1.amazonaws.com/public/images/street-conditions/regions/';

  constructor(private contentService: ContentService) {
  }

  transform(entry: Models.ContentEntry): Models.StreetConditionEntry | Models.StreetConditionEntry[] {
    if (!entry) {
      return null;
    }

    if (entry.related && entry.related.entries && entry.related.entries.length > 0) {
      const entries: any = [];

      for (const item of entry.related.entries) {
        const contentEntry = this.contentService.getEntry(item.id);
        let streetEntry = {
          title: contentEntry.title,
          region: contentEntry.detail.region,
          messages: contentEntry.detail.messages,
          sourceId: contentEntry._id,
          media: [{
            URL: this.mediaPath + contentEntry.detail.region + '.png',
            type: 'image'
          }]
        };
        entries.push(streetEntry);
      }

      return entries;

    } else {
      return null;
    }
  }
}
